import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useHistory } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
  Modal,
} from "reactstrap"
import { Carousel } from "react-responsive-carousel"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"
import ScrollContainer from "react-indiana-drag-scroll"

import "pages/AuthenticationInner/yt_styles.css"
import YoutubeEmbed from "pages/AuthenticationInner/YoutubeEmbed"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

// import images
import customize from "assets/images/ugifts/dummyBanner/customize.png"
import invite from "assets/images/ugifts/dummyBanner/invite.png"
import morebg from "assets/images/ugifts/more_bg.png"
import product1 from "assets/images/ugifts/dummyBanner/product1.png"
import product2 from "assets/images/ugifts/dummyBanner/product2.png"
import card1 from "assets/images/ugifts/dummyBanner/card1.png"
import card2 from "assets/images/ugifts/dummyBanner/card2.png"
import { Button } from "@material-ui/core"
import iconRibbon from "assets/images/ugifts/icon_ribbon.png"
import inviteFriendBg from "assets/images/ugifts/invite_friend_bg.png"

import bannerBlank from "assets/images/ugifts/icons/blank/banner_blank.png"
import brandBlank from "assets/images/ugifts/icons/blank/brand_blank.png"
import cardBlank from "assets/images/ugifts/icons/blank/card_blank.png"
import categoriesBlank from "assets/images/ugifts/icons/blank/categories_icon_blank.png"
import discoverBlank from "assets/images/ugifts/icons/blank/discover_blank.png"
import productBlank from "assets/images/ugifts/icons/blank/product_blank.png"
import slideBlank from "assets/images/ugifts/icons/blank/slide_blank.png"

const Home = props => {
  const history = useHistory()

  const [token, setToken] = useState(null)
  const [uid, setUid] = useState(null)
  const [youtubeURL, setYoutubeURL] = useState("")
  const [currency, setCurrency] = useState("")
  const [basketCount, setBasketCount] = useState(null)
  const [country, setCountry] = useState("")
  const [isGuest, setIsGuest] = useState(false)

  const [language, setLanguage] = useState("eng")

  useEffect(() => {
    // localStorage.removeItem("authAPI")
    // localStorage.removeItem("authUser")

    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }

    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      setUid(obj.member_id)
      console.log(obj)
    } else {
      // history.push("/login")
      setIsGuest(true)
    }

    if (localStorage.getItem("currency")) {
      setCurrency(localStorage.getItem("currency"))
    }

    if (localStorage.getItem("basketCount")) {
      setBasketCount(localStorage.getItem("basketCount"))
    }

    if (localStorage.getItem("country")) {
      setCountry(localStorage.getItem("country"))
    } else {
      // const obj = JSON.parse(localStorage.getItem("authUser"))
      // setCountry(obj.country_id)
      setCountry(3)
      // localStorage.setItem("country", obj.country_id)
      localStorage.setItem("country", 3)
    }

    if (localStorage.getItem("I18N_LANGUAGE")) {
      setLanguage(localStorage.getItem("I18N_LANGUAGE"))
    }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token && country) {
      // getRecommendList()
      getPopularList()
      getDiscoverList()
      getGiftList()
      getBannerList()
      getPopupList()
      getCountryList()
      if (!isGuest) {
        getUserProfile()
        getBasketData()
      }
      console.log("use effect")
    }
  }, [token, country])

  const [popupIndex, setPopupIndex] = useState(0)
  const [popupData, setPopupData] = useState(null)
  const getPopupList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "list_popup")
    urlencoded.append("order_by", "ASC")
    urlencoded.append("filter_by_country_id", country)
    if (!isGuest) urlencoded.append("member_id", uid)
    // urlencoded.append("filter_by_editable", "noneditable")
    // urlencoded.append("limit", 5)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request popup", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_FRONTEND, requestOptions)
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setPopupIndex(0)
      setPopupData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [bannerData, setBannerData] = useState(null)
  const getBannerList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "list_banner")
    urlencoded.append("order_by", "ASC")
    urlencoded.append("filter_by_country_id", country)
    // urlencoded.append("filter_by_editable", "noneditable")
    // urlencoded.append("limit", 5)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request banner", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_FRONTEND, requestOptions)
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setBannerData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const markNotShowAgain = async popup_id => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "mark_not_show_again")
    urlencoded.append("member_id", uid)
    urlencoded.append("popup_id", popup_id)
    // urlencoded.append("filter_by_editable", "noneditable")
    // urlencoded.append("limit", 5)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request mark not show again", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_FRONTEND, requestOptions)
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      // setBannerData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [giftData, setGiftData] = useState(null)
  const getGiftList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "list_giftcard")
    // urlencoded.append("order_by", "ASC")
    // urlencoded.append("filter_by_editable", "noneditable")
    urlencoded.append("limit", 5)
    urlencoded.append("filter_by_country_id", country)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request gift card list", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_GIFT, requestOptions)
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setGiftData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [discoverData, setDiscoverData] = useState(null)
  const getDiscoverList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "list_category")
    // urlencoded.append("order_by", "ASC")
    urlencoded.append("limit", 2)
    urlencoded.append("filter_by_country_id", country)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request category", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_POST_GET_CATEGORY,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setDiscoverData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [popularData, setPopularData] = useState(null)
  const getPopularList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "list_product")
    urlencoded.append("order_by", "POPULAR")
    urlencoded.append("limit", 5)
    urlencoded.append("member_id", uid)
    urlencoded.append("filter_by_country_id", country)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request list product", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_POST_GET_CATEGORY,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setPopularData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const getRecommendList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "list_gift_advice_parameters")
    // urlencoded.append("order_by", "POPULAR")
    // urlencoded.append("limit", 5)
    urlencoded.append("member_id", uid)
    // urlencoded.append("filter_by_country_id", country)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request list gift advice", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_POST_GET_CATEGORY,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    // if (response.status == 200) {
    //   // history.push("/tables-applicationtable")
    //   setPopularData(postresponse.table)
    // } else {
    //   // seterror_alert(true)
    // }
  }

  const [userData, setUserData] = useState(null)
  const getUserProfile = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_profile")
    urlencoded.append("member_id", uid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request detail profile", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setUserData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const getBasketData = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_basket")
    urlencoded.append("member_id", uid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request basket", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_BASKET,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      var calculate = 0
      postresponse.table.products.forEach(product => {
        calculate += parseInt(product.quantity)
      })
      setBasketCount(calculate)
      // if (postresponse.table.currency != "SGD") {
      //   setMarketCountry(3)
      // }
      localStorage.setItem("basketCount", calculate)
    } else {
      // seterror_alert(true)
    }
  }

  const setMarketCountry = async cid => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "set_market_country")
    urlencoded.append("member_id", uid)
    urlencoded.append("country_id", cid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request set market country", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_BASKET,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
    } else {
      // seterror_alert(true)
    }
  }

  const [countryData, setCountryData] = useState(null)
  const getCountryList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "list_country")
    urlencoded.append("order_by", "ASC")

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request country", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setCountryData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (countryData && userData) {
      var currency_code = countryData.filter(data => data.id == country)
      if (currency_code.length > 0) {
        setCurrency(currency_code[0].currency_code)
        localStorage.setItem("currency", currency_code[0].currency_code)
      }
    }

    if (countryData) {
      var currency_code = countryData.filter(data => data.id == country)
      if (currency_code.length > 0) {
        setCurrency(currency_code[0].currency_code)
        localStorage.setItem("currency", currency_code[0].currency_code)
      }
    }
  }, [countryData, userData])

  function onClickBanner(linkage_type, linkage_detail) {
    switch (linkage_type) {
      case "linkage_url":
        window.open(linkage_detail)
        break
      case "linkage_product":
        history.push("/product-details?id=" + linkage_detail)
        break
      case "linkage_video":
        tog_yt(linkage_detail)
        break
      case "linkage_campaign":
        history.push("/campaign?id=" + linkage_detail)
        break
    }
  }

  function onClickPopup(linkage_type, linkage_detail) {
    switch (linkage_type) {
      case "linkage_url":
        window.open(linkage_detail)
        break
      case "linkage_product":
        history.push("/product-details?id=" + linkage_detail)
        break
      case "linkage_video":
        tog_yt(linkage_detail)
        break
      case "linkage_campaign":
        history.push("/campaign?id=" + linkage_detail)
        break
    }
  }

  const [modal_available, setmodal_available] = useState(false)
  const [modal_yt, setmodal_yt] = useState(false)
  const [modal_popup, setmodal_popup] = useState(false)

  function tog_available() {
    setmodal_available(!modal_available)
    removeBodyCss()
  }

  function tog_yt(url) {
    setmodal_yt(!modal_yt)
    if (url) setYoutubeURL(url)
    removeBodyCss()
  }

  function tog_popup() {
    setmodal_popup(true)
    removeBodyCss()
  }

  function close_popup() {
    if (popupIndex + 1 < popupData.length) {
      console.log("continue")
      setPopupIndex(popupIndex + 1)
      tog_popup()
    } else {
      setmodal_popup(false)
    }
  }

  useEffect(() => {
    if (popupData) {
      if (popupData.length > 0) tog_popup()
    }
  }, [popupData])

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  function onImageError(e, blank) {
    if (e.target.src !== blank) {
      e.target.onError = null
      e.target.src = blank
    }
  }

  const multiLanguageHandler = data => {
    switch (language) {
      case "eng":
        return data.en
      case "cn":
        return data.cn ? data.cn : data.en
      case "jp":
        return data.jp ? data.jp : data.en
      default:
        return data.en
    }
  }

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            {/* <CarouselPage /> */}

            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{
                  minHeight: "100vh",
                  paddingTop: "60px",
                  paddingBottom: "76px",
                }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "56px",
                        backgroundColor: "#009FE2",
                        position: "fixed",
                        top: 0,
                        zIndex: 1030,
                        maxWidth: "480px",
                      }}
                    >
                      <Col xs={2} className="ps-0">
                        {/* <Link to="#"> */}
                        <Button className="h-100 m-0" onClick={tog_available}>
                          <img
                            src={
                              !isGuest
                                ? countryData &&
                                  userData &&
                                  countryData.filter(data => data.id == country)
                                    .length > 0 &&
                                  countryData.filter(
                                    data => data.id == country
                                  )[0].image
                                : countryData &&
                                  countryData.filter(data => data.id == country)
                                    .length > 0 &&
                                  countryData.filter(
                                    data => data.id == country
                                  )[0].image
                            }
                            className="rounded-circle avatar-xs"
                            alt=""
                          />
                          {/* <i className="bx bx-credit-card-front align-middle font-size-20 text-white" /> */}
                        </Button>
                        {/* </Link> */}
                      </Col>
                      <Col xs={8} className="align-self-center">
                        {/* <p className="h-100 text-white font-size-15 my-auto text-center">
                          Create New Password
                        </p> */}
                      </Col>
                      <Col xs={2} className="pe-0">
                        <Link to="/basket">
                          <Button className="h-100 m-0">
                            <i className="bx bx-basket align-middle font-size-28 text-white" />
                            {!isGuest && basketCount != 0 && (
                              <span
                                className="badge bg-danger rounded-pill"
                                style={{
                                  position: "absolute",
                                  top: 12,
                                  right: 8,
                                }}
                              >
                                {basketCount}
                              </span>
                            )}
                          </Button>
                        </Link>
                      </Col>
                    </Row>
                    <Row>
                      <Carousel
                        infiniteLoop
                        autoPlay
                        swipeable
                        emulateTouch
                        interval={5000}
                        showThumbs={false}
                        className="slider_css"
                        dir="rtl"
                        onClickItem={e => {
                          bannerData &&
                            onClickBanner(
                              bannerData[e].linkage_type,
                              bannerData[e].linkage_detail
                            )
                        }}
                      >
                        {bannerData &&
                          bannerData.map((banner, index) => (
                            <div>
                              <div className="item">
                                <Card className="text-center px-3 pt-3 shadow-none">
                                  <CardImg
                                    top
                                    className="img-fluid"
                                    style={{
                                      // height: "280px",
                                      objectFit: "cover",
                                      borderRadius: "14px",
                                      aspectRatio: "3/2",
                                    }}
                                    src={banner.image}
                                    alt=""
                                    onError={e => {
                                      onImageError(e, bannerBlank)
                                    }}
                                  />
                                </Card>
                              </div>
                            </div>
                          ))}
                        {/* {banners.map((banner, index) => (
                          <div>
                            <div className="item">
                              <Card
                                className="text-center px-3 pt-3"
                                // style={{ borderRadius: "16px" }}
                              >
                                <CardImg
                                  top
                                  className="img-fluid"
                                  style={{
                                    height: "280px",
                                    objectFit: "cover",
                                    borderRadius: "8px",
                                  }}
                                  src={banner.image}
                                  alt=""
                                />
                              </Card>
                            </div>
                          </div>
                        ))} */}
                      </Carousel>
                    </Row>
                    {/* <Row>
                      <Col>
                        <Link to="/gift-card?type=editable">
                          <Card
                            className="px-3 shadow-none"
                            style={{ borderRadius: "14px" }}
                          >
                            <CardImg
                              top
                              className="img-fluid"
                              src={customize}
                              alt=""
                              style={{ borderRadius: "14px" }}
                            />
                          </Card>
                        </Link>
                      </Col>
                    </Row> */}
                    {giftData && giftData.length > 0 && (
                      <Row className="px-3 mb-2">
                        <Col xs="6">
                          <span
                            className="mb-0 font-size-20"
                            style={{ fontWeight: 700 }}
                          >
                            {props.t("Send a Gift Card")}
                          </span>
                        </Col>
                        <Col
                          xs="6"
                          className="font-size-14 text-end align-self-center"
                          style={{ fontWeight: 500 }}
                        >
                          <Link to="/gift-card">{props.t("See all")}</Link>
                        </Col>
                      </Row>
                    )}
                    <Row className="">
                      <Col>
                        <ScrollContainer className="scroll-container px-3">
                          <Row className="flex-nowrap">
                            {giftData &&
                              giftData.map((data, index) => (
                                <Col xs="auto">
                                  <Link to={"/gift-card-product?id=" + data.id}>
                                    <Card
                                      className="shadow-none"
                                      style={{
                                        borderRadius: "12px",
                                        width: "160px",
                                        // height: "196px",
                                        backgroundColor: "white",
                                      }}
                                    >
                                      <CardImg
                                        top
                                        className="img-fluid mb-2"
                                        src={data.image_thumbnail}
                                        alt=""
                                        style={{
                                          width: "160px",
                                          aspectRatio: "3/2",
                                          objectFit: "cover",
                                          borderRadius: "14px",
                                        }}
                                        onError={e => {
                                          onImageError(e, cardBlank)
                                        }}
                                      />
                                      <CardTitle
                                        className="font-size-12 text-dark"
                                        style={{ fontWeight: 700 }}
                                      >
                                        {
                                          multiLanguageHandler(
                                            data.multiple_languages
                                          ).name
                                        }
                                      </CardTitle>
                                    </Card>
                                  </Link>
                                </Col>
                              ))}
                          </Row>
                        </ScrollContainer>
                      </Col>
                    </Row>
                    {/* <Row className="px-3">
                      <Col>
                        <Row
                          className="flex-nowrap"
                          style={{ overflow: "auto" }}
                        >
                          {giftData &&
                            giftData.map((data, index) => (
                              <Col xs="auto">
                                <Link to={"/gift-card-product?id=" + data.id}>
                                  <Card
                                    className=""
                                    style={{
                                      borderRadius: "12px",
                                      width: "160px",
                                      // height: "196px",
                                      backgroundColor: "white",
                                    }}
                                  >
                                    <CardImg
                                      top
                                      className="img-fluid mb-2"
                                      src={data.image}
                                      alt=""
                                      style={{ width: "160px", height: "92px" }}
                                    />
                                    <CardTitle
                                      className="font-weight-normal text-dark"
                                      style={{ fontWeight: 400 }}
                                    >
                                      {data.giftcard_name}
                                    </CardTitle>
                                  </Card>
                                </Link>
                              </Col>
                            ))}
                        </Row>
                      </Col>
                    </Row> */}
                    <Row className="px-3 mb-2">
                      <Col>
                        <span
                          className="mb-0 font-size-20"
                          style={{ fontWeight: 700 }}
                        >
                          {props.t("Discover")}
                        </span>
                      </Col>
                      <Col
                        xs="6"
                        className="font-size-14 text-end align-self-center"
                        style={{ fontWeight: 500 }}
                      >
                        <Link to="/categories">{props.t("See all")}</Link>
                      </Col>
                    </Row>
                    <Row className="">
                      <Col>
                        <ScrollContainer className="scroll-container px-3">
                          <Row className="flex-nowrap">
                            {discoverData &&
                              discoverData.map((data, index) => (
                                <Col xs="auto">
                                  <Link
                                    to={
                                      "/products?id=" +
                                      data.id +
                                      "&type=list_category"
                                    }
                                  >
                                    <Card
                                      className="p-3 shadow-none"
                                      style={{
                                        borderRadius: "14px",
                                        width: "160px",
                                        height: "106px",
                                        backgroundColor: "#DEDEDE",
                                        backgroundImage: `url("${data.image_home}")`,
                                        backgroundSize: "cover",
                                      }}
                                    >
                                      <Row className="mt-auto">
                                        <Col>
                                          <span
                                            className="font-size-12 text-dark"
                                            style={{ fontWeight: 700 }}
                                          >
                                            {
                                              multiLanguageHandler(
                                                data.multiple_languages
                                              ).name
                                            }
                                          </span>
                                        </Col>
                                      </Row>
                                    </Card>
                                  </Link>
                                </Col>
                              ))}
                            {discoverData && (
                              <Col>
                                <Link to="/categories">
                                  <Card
                                    className="p-3 shadow-none"
                                    style={{
                                      borderRadius: "14px",
                                      width: "160px",
                                      height: "106px",
                                      backgroundColor: "#DEDEDE",
                                      backgroundImage: `url("${morebg}")`,
                                      backgroundSize: "cover",
                                    }}
                                  >
                                    <Row className="mt-auto">
                                      <Col>
                                        <span
                                          className="font-size-12 text-dark"
                                          style={{ fontWeight: 700 }}
                                        >
                                          {props.t("More")}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Card>
                                </Link>
                              </Col>
                            )}
                          </Row>
                        </ScrollContainer>
                      </Col>
                    </Row>
                    {/* <Row className="px-3">
                      {discoverData &&
                        discoverData.map((data, index) => (
                          <Col>
                            <Link
                              to={
                                "/products?id=" +
                                data.id +
                                "&type=list_category"
                              }
                            >
                              <Card
                                className="px-3"
                                // style={{ borderRadius: "16px" }}
                                style={{
                                  borderRadius: "8px",
                                  aspectRatio: "1",
                                  backgroundColor: "#DEDEDE",
                                  backgroundImage: `url("${data.image_home}")`,
                                  backgroundSize: "cover",
                                }}
                              >
                                <Row className="mt-2">
                                  <Col>
                                    <span
                                      className="font-size-14 text-dark"
                                      style={{ fontWeight: 700 }}
                                    >
                                      {data.name}
                                    </span>
                                  </Col>
                                </Row>
                              </Card>
                            </Link>
                          </Col>
                        ))}
                      {discoverData && (
                        <Col>
                          <Link to="/categories">
                            <Card
                              className="px-3"
                              style={{
                                borderRadius: "12px",
                                aspectRatio: "1",
                                backgroundColor: "#DEDEDE",
                                backgroundImage: `url("${morebg}")`,
                                backgroundSize: "cover",
                              }}
                            >
                              <Row className="mt-2">
                                <Col>
                                  <span
                                    className="font-size-14 text-dark"
                                    style={{ fontWeight: 700 }}
                                  >
                                    More
                                  </span>
                                </Col>
                              </Row>
                            </Card>
                          </Link>
                        </Col>
                      )}
                    </Row> */}
                    {!isGuest && (
                      <Row>
                        <Col>
                          <Link to="/invite-friend">
                            <Card
                              className="p-3 mx-3 shadow-none bg-primary"
                              style={{
                                borderRadius: "14px",
                                backgroundImage: `url("${inviteFriendBg}")`,
                                backgroundSize: "cover",
                              }}
                            >
                              <CardImg
                                // top
                                // className="img-fluid"
                                src={iconRibbon}
                                alt=""
                                style={{
                                  borderRadius: "14px",
                                  height: "15px",
                                  width: "45px",
                                }}
                              />
                              <Row>
                                <Col>
                                  <span
                                    className="mb-0 font-size-20 text-uppercase text-white"
                                    style={{ fontWeight: 700 }}
                                  >
                                    {props.t("Invite A Friend")}
                                  </span>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <span className="mb-0 font-size-12 text-white">
                                    {props.t("And earn rewards")}
                                  </span>
                                </Col>
                              </Row>
                              {/* <CardImg
                                top
                                className="img-fluid"
                                src={invite}
                                alt=""
                                style={{ borderRadius: "14px" }}
                              /> */}
                            </Card>
                          </Link>
                        </Col>
                      </Row>
                    )}
                    {popularData && popularData.length > 0 && (
                      <Row className="px-3 mb-2">
                        <Col xs="6">
                          <span
                            className="mb-0 font-size-20 text-black"
                            style={{ fontWeight: 700 }}
                          >
                            {props.t("Popular")}
                          </span>
                        </Col>
                        <Col
                          xs="6"
                          className="font-size-14 text-end align-self-center"
                          style={{ fontWeight: 500 }}
                        >
                          <Link to="/product-search?filter=popular">
                            {props.t("See all")}
                          </Link>
                        </Col>
                      </Row>
                    )}
                    <Row className="">
                      <Col>
                        <ScrollContainer className="scroll-container px-3">
                          <Row
                            className="flex-nowrap"
                            // style={{ overflow: "auto" }}
                          >
                            {popularData &&
                              popularData.map((data, index) => (
                                <Col xs="auto">
                                  <Link to={"/product-details?id=" + data.id}>
                                    <Card
                                      className="px-3 shadow-none"
                                      // backgroundImage={data.image}
                                      style={{
                                        borderRadius: "14px",
                                        width: "160px",
                                        height: "196px",
                                        backgroundImage: `url("${data.image}")`,
                                        backgroundSize: "cover",
                                      }}
                                    >
                                      <Row className="mt-auto">
                                        <Col>
                                          <Row className="mt-auto">
                                            <Col>
                                              <span
                                                className="font-size-12 text-white"
                                                style={{
                                                  fontWeight: 700,
                                                  lineHeight: "14px",
                                                  display: "inline-block",
                                                }}
                                              >
                                                {
                                                  multiLanguageHandler(
                                                    data.multiple_languages
                                                  ).name
                                                }
                                              </span>
                                            </Col>
                                          </Row>
                                          <Row className="mt-auto">
                                            <Col xs="auto" className="">
                                              <span
                                                className="font-size-15 text-white"
                                                style={{ fontWeight: 700 }}
                                              >
                                                {currency +
                                                  " " +
                                                  data.discounted_price}
                                              </span>
                                            </Col>
                                          </Row>
                                          <Row
                                            className={
                                              data.campaign_info &&
                                              (data.campaign_info.discount_mode
                                                ? "mt-auto"
                                                : "mt-auto mb-2")
                                            }
                                          >
                                            {data.discounted_price !=
                                              data.original_price && (
                                              <Col
                                                xs="auto"
                                                className="align-self-end"
                                              >
                                                <span
                                                  className="font-size-10 text-white"
                                                  style={{ fontWeight: 500 }}
                                                >
                                                  <s>
                                                    {currency +
                                                      " " +
                                                      data.original_price}
                                                  </s>
                                                </span>
                                              </Col>
                                            )}
                                          </Row>
                                          {data.campaign_info &&
                                            (data.campaign_info
                                              .discount_mode ? (
                                              <Row className="mt-auto mb-2">
                                                <Col>
                                                  <i className="bx bxs-discount align-middle font-size-12 text-white me-1" />
                                                  <span
                                                    className="font-size-10 text-white align-middle"
                                                    style={{
                                                      lineHeight: "10px",
                                                    }}
                                                  >
                                                    {data.campaign_info &&
                                                      data.campaign_info
                                                        .discount_message}
                                                  </span>
                                                </Col>
                                              </Row>
                                            ) : null)}
                                        </Col>
                                      </Row>
                                    </Card>
                                  </Link>
                                </Col>
                              ))}
                          </Row>
                        </ScrollContainer>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={modal_available}
        toggle={() => {
          tog_available()
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            {props.t("Choose Location")}
          </h5>
          <button
            type="button"
            onClick={() => {
              setmodal_available(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Row className="mb-2">
            <Col>
              <strong>
                <span className="font-size-22 text-dark">
                  {props.t("Your Current Location")}
                </span>
              </strong>
            </Col>
          </Row>
          {countryData &&
            countryData.map((data, index) => (
              <div>
                <Row
                  className="mb-2"
                  onClick={() => {
                    localStorage.setItem("country", data.id)
                    setCountry(data.id)
                    setMarketCountry(data.id)
                    tog_available()
                  }}
                >
                  <Col xs="auto">
                    <img
                      src={data.image}
                      className="rounded-circle avatar-xs"
                      alt=""
                    />
                  </Col>
                  <Col>
                    <span className="font-size-15">{data.name}</span>
                  </Col>
                  <Col xs="auto">
                    <span className="font-size-15">
                      {userData && country == data.id && (
                        <i className="bx bx-comment-check align-middle font-size-20 text-dark" />
                      )}
                    </span>
                  </Col>
                </Row>
                <hr
                  style={{
                    color: "#EAEAEA",
                    backgroundColor: "#EAEAEA",
                    height: "2px",
                  }}
                />
              </div>
            ))}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              tog_available()
            }}
            className="btn btn-secondary waves-effect"
            data-dismiss="modal"
          >
            {props.t("Close")}
          </button>
          {/* <button
            type="button"
            className="btn btn-primary waves-effect waves-light"
          >
            Save changes
          </button> */}
        </div>
      </Modal>
      <Modal
        isOpen={modal_yt}
        toggle={() => {
          tog_yt(false)
        }}
        // className="modal-fullscreen"
        centered={true}
      >
        <div className="modal-header" style={{ borderBottom: "none" }}>
          <h5 className="modal-title mt-0" id="myModalLabel">
            {/* {"Choose Location"} */}
          </h5>
          <button
            type="button"
            onClick={() => {
              tog_yt(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Row className="mb-2">
            <Col>
              <YoutubeEmbed embedId={youtubeURL} />
            </Col>
          </Row>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              tog_yt(false)
            }}
            className="btn btn-secondary waves-effect"
            data-dismiss="modal"
          >
            {props.t("Close")}
          </button>
          {/* <button
            type="button"
            className="btn btn-primary waves-effect waves-light"
          >
            Save changes
          </button> */}
        </div>
      </Modal>
      <Modal
        isOpen={modal_popup}
        toggle={() => {
          close_popup()
        }}
        // className="modal-fullscreen"
        centered={true}
      >
        <div className="modal-header" style={{ borderBottom: "none" }}>
          <h5 className="modal-title mt-0" id="myModalLabel">
            {/* {"Choose Location"} */}
          </h5>
          <button
            type="button"
            onClick={() => {
              close_popup()
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Row className="mb-2 px-3">
            <Col className="p-0">
              <Card className="shadow-none">
                {popupData && popupData[popupIndex] && (
                  <CardImg
                    top
                    className="img-fluid mb-3"
                    style={
                      {
                        // height: "280px",
                        // objectFit: "cover",
                        // borderRadius: "8px",
                      }
                    }
                    src={popupData[popupIndex].image}
                    alt=""
                    onError={e => {
                      onImageError(e, cardBlank)
                    }}
                  />
                )}
                {popupData && popupData[popupIndex] && (
                  <div>
                    <Row>
                      <Col>
                        <strong>
                          <span
                            className="font-size-20"
                            style={{ fontWeight: 500 }}
                          >
                            {popupData[popupIndex].linkage_info.name}
                          </span>
                        </strong>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col xs="auto">
                        <span className="font-size-14">
                          <strong>{props.t("Description")}</strong>
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs="auto">
                        <span
                          className="font-size-14"
                          dangerouslySetInnerHTML={{
                            __html:
                              popupData[popupIndex].linkage_info.description,
                          }}
                        ></span>
                      </Col>
                    </Row>
                  </div>
                )}
              </Card>
            </Col>
          </Row>
          <Row className="mb-3 px-3">
            <button
              type="button"
              onClick={() => {
                popupData &&
                  popupData[popupIndex] &&
                  onClickPopup(
                    popupData[popupIndex].linkage_type,
                    popupData[popupIndex].linkage_detail
                  )
              }}
              className="btn btn-danger waves-effect font-size-18"
              data-dismiss="modal"
            >
              {props.t("Go")}
            </button>
          </Row>
          <Row className="justify-content-center px-3">
            <button
              // to={"/home"}
              className="btn btn-outline-dark font-size-18"
              // style={{ height: "42px" }}
              onClick={() => {
                popupData &&
                  popupData[popupIndex] &&
                  markNotShowAgain(popupData[popupIndex].id)
                close_popup()
              }}
            >
              {props.t("Don't Show Again")}
            </button>
          </Row>
        </div>
        {/* <div className="modal-footer justify-content-around">
          <Row>
            <button
              type="button"
              onClick={() => {
                popupData &&
                  popupData[popupIndex] &&
                  onClickPopup(
                    popupData[popupIndex].linkage_type,
                    popupData[popupIndex].linkage_detail
                  )
              }}
              className="btn btn-primary waves-effect"
              data-dismiss="modal"
            >
              Go
            </button>
          </Row>
        </div> */}
      </Modal>
    </React.Fragment>
  )
}

export default withTranslation()(Home)

Home.propTypes = {
  t: PropTypes.any,
}
